module.exports = function (input) {

    if (input === null || input === 'null') {
        return input;
    }

    input = (input + '' || '').toLowerCase().trim();
    return input.replace(/[^a-z0-9']+/gi, '-'); //Replace non alpha numeric strings with a hyphen.
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/stringhelpers/hyphenate.js
 **/